import { css } from "emotion";
import { max } from "../../../../utils/CssUtils";

const Flag = ({
  showArrow = true,
  arrowSpacing = 20,
  custom = false,
  arrowMobileSpacing = arrowSpacing,
  breakpoint = 600,
  className = css({}),
  children
}) => {
  const purpLine = css({
    width: 4,
    flexShrink: 0,
    height: "100%",
    display: "inline-block",
    backgroundColor: "#6621c0",
    position: "absolute",
    left: 0,
    [max(breakpoint)]: {
      top: 0,
      width: "100%",
      height: 4
    }
  });

  const standard = css({
    maxWidth: 480,
    minHeight: 120,
    backgroundColor: "white",
    img: {
      objectFit: "contain",
      maxWidth: 120,
      maxHeight: 80,
      minWidth: 75,
      marginRight: 24,
      marginLeft: 10,
      flexShrink: 2
    },
    p: {
      maxWidth: 300,
      minHeight: 88,
      flexShrink: 1
    },
    [max(breakpoint)]: {
      justifyContent: "space-between",
      img: {
        maxWidth: 115,
        margin: "16px 0 18px 0"
      },
      p: {
        maxWidth: "100%",
        minHeight: 0,
        margin: "0 2px"
      }
    }
  });

  const arrow = css({
    "&::before": {
      content: `''`,
      backgroundImage: "url(../../../../assets/ic_long_arrow.svg)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      position: "absolute",
      top: "50%",
      transform: "translate(-100%, -50%)",
      left: -arrowSpacing,
      width: 39,
      height: 14,
      [max(breakpoint)]: {
        top: -arrowMobileSpacing,
        transform: "translate(-50%, -100%) rotate(90deg)",
        left: "50%"
      }
    }
  });

  const minStyles = css({
    padding: 10,
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: showArrow ? `${arrowSpacing + 39}px` : 0,
    [max(breakpoint)]: {
      flexDirection: "column",
      height: "auto",
      marginTop: showArrow ? `${arrowMobileSpacing + 39}px` : 0,
      marginLeft: 0
    }
  });

  const flex = custom ? minStyles : css([minStyles, standard]);

  const wrapper = showArrow ? css([flex, arrow]) : flex;

  return (
    <div className={css([wrapper, className])}>
      <div className={purpLine} />
      {children}
    </div>
  );
};

export default Flag;
